import AnalyzePerformanceHeaderBar from "./AnalyzePerformanceHeaderBar";
import "./AnalyzePerformanceHeaderBar.scss";

export default AnalyzePerformanceHeaderBar